var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelSOutline16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5307 4.46967C11.8236 4.76257 11.8236 5.23744 11.5307 5.53033L9.06089 8.0001L11.5308 10.4696C11.8238 10.7625 11.8238 11.2373 11.5309 11.5303C11.2381 11.8232 10.7632 11.8232 10.4703 11.5304L8.00022 9.06076L5.5307 11.5302C5.2378 11.8231 4.76293 11.8231 4.47004 11.5302C4.17714 11.2373 4.17715 10.7625 4.47004 10.4696L6.93946 8.0002L4.46972 5.53093C4.1768 5.23806 4.17675 4.76319 4.46962 4.47027C4.76248 4.17734 5.23736 4.1773 5.53028 4.47017L8.00013 6.93954L10.47 4.46967C10.7629 4.17677 11.2378 4.17678 11.5307 4.46967Z",
    fill: "#36575F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSOutline16);
export default __webpack_public_path__ + "static/media/cancel_s_outline_16.7bb8e309470d849b635f74d2aeb8e71a.svg";
export { ForwardRef as ReactComponent };